import React from 'react';
import { Twitter, Linkedin, Github } from 'lucide-react';

const FOOTER_LINKS = {
  Produit: [
    { label: 'Fonctionnalités', href: '#features' },
    { label: 'Tarifs', href: '#pricing' },
    { label: 'Changelog', href: '#' },
    { label: 'Roadmap', href: '#' },
  ],
  Ressources: [
    { label: 'Documentation', href: '#' },
    { label: 'Guide IT & Réseau', href: '/it-guide' },
    { label: 'API', href: '#' },
    { label: 'Blog', href: '#' },
  ],
  Entreprise: [
    { label: 'À propos', href: '#' },
    { label: 'Contact', href: '#' },
    { label: 'Carrières', href: '#' },
    { label: 'Presse', href: '#' },
  ],
  Légal: [
    { label: 'Confidentialité', href: '/privacy' },
    { label: 'CGU', href: '/terms' },
    { label: 'Cookies', href: '#' },
    { label: 'Mentions légales', href: '#' },
  ],
};

export function MarketingFooter() {
  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-1">
            <a href="/" className="flex items-center gap-2 mb-4">
              <svg viewBox="0 0 40 40" className="w-8 h-8">
                <defs>
                  <linearGradient id="footer-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#6366F1" />
                    <stop offset="100%" stopColor="#8B5CF6" />
                  </linearGradient>
                </defs>
                <path
                  d="M12 8 C10 2, 6 2, 8 12 C9 16, 12 18, 14 20"
                  fill="none"
                  stroke="url(#footer-gradient)"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
                <path
                  d="M28 8 C30 2, 34 2, 32 12 C31 16, 28 18, 26 20"
                  fill="none"
                  stroke="url(#footer-gradient)"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
                <circle cx="20" cy="26" r="10" fill="url(#footer-gradient)" />
              </svg>
              <span className="text-lg font-bold text-white">Lapyno</span>
            </a>
            <p className="text-sm text-slate-400 mb-4">
              La gestion de projet moderne pour les équipes qui veulent avancer.
            </p>
            {/* Social links */}
            <div className="flex gap-3">
              <a href="#" className="p-2 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-white transition-colors">
                <Twitter className="h-4 w-4" />
              </a>
              <a href="#" className="p-2 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-white transition-colors">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="#" className="p-2 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-white transition-colors">
                <Github className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(FOOTER_LINKS).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-semibold text-white mb-4">{title}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <a 
                      href={link.href}
                      className="text-sm text-slate-400 hover:text-white transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} Lapyno. Tous droits réservés.
          </p>
          <p className="text-sm text-slate-500">
            Fait avec ❤️ en France
          </p>
        </div>
      </div>
    </footer>
  );
}
